const AFFILIATE_URL = "https://bc072hg2p7rncg20qs5ev03po2.hop.clickbank.net";

export const Ingredients = () => {
  const ingredients = [
    {
      name: "Citrus Aurantium",
      description: "The star ingredient — bitter orange extract containing synephrine, clinically shown to support thermogenesis and boost fat oxidation naturally.",
      image: "https://images.unsplash.com/photo-1642840894330-44b37aca232c?w=400",
    },
    {
      name: "Green Tea Extract",
      description: "Packed with EGCG catechins that enhance metabolic rate, support healthy weight management, and provide antioxidant protection.",
      image: "https://images.unsplash.com/photo-1588578606909-db963679a720?w=400",
    },
    {
      name: "Capsaicin Complex",
      description: "Derived from hot peppers, this compound promotes thermogenesis, helps reduce appetite, and supports healthy circulation.",
      image: "https://images.unsplash.com/photo-1583119912267-cc97c911e416?w=400",
    },
    {
      name: "Ginger Root Extract",
      description: "Supports healthy digestion, enhances the thermic effect of food, and provides natural anti-inflammatory benefits.",
      image: "https://images.unsplash.com/photo-1615485290382-441e4d049cb5?w=400",
    },
  ];

  return (
    <section data-testid="ingredients-section" className="py-16 md:py-20 bg-white" aria-labelledby="ingredients-heading">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <a href={AFFILIATE_URL} target="_blank" rel="noopener noreferrer" className="block">
          <div className="text-center mb-12 cursor-pointer">
            <span className="inline-block bg-[#FFF5E6] text-[#FF6B00] text-xs font-bold px-4 py-1.5 rounded-full mb-4 uppercase tracking-wider">
              Premium Formula
            </span>
            <h2 id="ingredients-heading" className="text-3xl md:text-4xl lg:text-5xl font-black text-[#1A1C19] mb-4" style={{ fontFamily: "Fraunces, serif" }}>
              What's Inside The <span className="text-[#FF6B00]">"Orange Peel Trick"</span>
            </h2>
            <p className="text-lg text-[#4A5043] max-w-2xl mx-auto">
              Each ingredient is carefully selected and clinically dosed for maximum effectiveness
            </p>
          </div>
        </a>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {ingredients.map((ingredient, index) => (
            <a key={index} href={AFFILIATE_URL} target="_blank" rel="noopener noreferrer" className="block">
              <article
                data-testid={`ingredient-card-${index}`}
                className="flex gap-5 bg-[#FFF9F5] rounded-2xl p-5 border border-[#FFE4CC] hover:shadow-lg transition-shadow cursor-pointer h-full"
              >
                <img
                  src={ingredient.image}
                  alt={`${ingredient.name} - natural fat burning ingredient for metabolic support`}
                  className="w-20 h-20 rounded-xl object-cover flex-shrink-0 border-2 border-[#FF6B00]"
                  loading="lazy"
                />
                <div>
                  <h3 className="text-lg font-bold text-[#1A1C19] mb-1" style={{ fontFamily: "Fraunces, serif" }}>
                    {ingredient.name}
                  </h3>
                  <p className="text-[#4A5043] text-sm leading-relaxed">{ingredient.description}</p>
                </div>
              </article>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Ingredients;
